import React from "react";

const PowerIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M12 2v10"/>
        <path d="M18.4 6.6a9 9 0 1 1-12.77.04"/>
    </svg>
);

export default PowerIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/PowerIcon.jsx